import React from 'react'
import { Link } from 'react-router-dom'

function NotFound() {
    const mouseEnter = (e) => {
        e.target.classList.add('text-decoration-underline')
    }
    const mouseLeave = (e) => {
        e.target.classList.remove('text-decoration-underline')
    }
  return (
    <div className='d-flex flex-column justify-content-center align-items-center' style={{minHeight:'81.6vh'}}>
    <h1>Ooh uh! You are in the wrong Place!</h1>
    <p className='fs-2 mt-2'><Link to={'/'} className='text-success text-decoration-none' onMouseEnter={(e)=>mouseEnter(e)} onMouseLeave={(e)=>mouseLeave(e)}>Go to HomePage</Link></p>
    </div>
  )
}

export default NotFound